"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewAccountPropsInterface = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var ViewAccountPropsInterface = {
  trackingSource: _propTypes.default.string.isRequired
};
exports.ViewAccountPropsInterface = ViewAccountPropsInterface;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/viewAccount/ViewAccountPropsInterface.js
// module id = 778
// module chunks = 5 6